import script from "./acquaint-date-box.vue?vue&type=script&setup=true&lang=ts"
export * from "./acquaint-date-box.vue?vue&type=script&setup=true&lang=ts"

import "./acquaint-date-box.vue?vue&type=style&index=0&id=f6cb7312&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6cb7312"]])

export default __exports__